<div class="container">
  <h5>Détails du produit {{product.name}}</h5>
  <form [formGroup]="form" (submit)="submit()">
    <label><strong>produit: </strong></label>
    <input type="text" nbInput fullWidth shape="semi-round" placeholder="nom du produit" formControlName="name">
    <br>
    <label for="image"></label><strong>Image du produit: </strong>
    <input type="text" nbInput fullWidth shape="semi-round" placeholder="Image du produit" formControlName="image"> 
    <br>   
    <label for="tag"></label><strong>Version: </strong>
    <input type="text" nbInput fullWidth shape="semi-round" placeholder="version du produit" formControlName="tag"> 
    <br>
    <label for="imageVariable"></label><strong>Variable de l'image: </strong>
    <em>Doit être identique à celui défini dans le template YAML (ex. <span style="color:#ff4474">SERVICE_PRODUCT_IMAGE</span>)</em>
    <input type="text" nbInput fullWidth shape="semi-round" placeholder="variable de l'image" formControlName="imageVariable">

    <div class="btn-class">
      <button class="cancel" nbButton status="danger" (click)="cancel()">Annuler</button>
      <button class="valider" nbButton status="primary" type="submit">Mettre à jour</button>
    </div>
    <em> Si vous effectuer des modifications sur le numéro de version, il vont être prisent en compte lors du prochain lancement</em>
  </form>
</div>
